import { Component, computed, EventEmitter, Input, Output, OnChanges, SimpleChanges, signal } from '@angular/core';

@Component({
  selector: 'main-menu',
  templateUrl: './main-menu.component.html',
  styleUrls: ['./main-menu.component.css'],
})
export class MainMenuComponent implements OnChanges {


  @Input() isLoggedIn: boolean;
  @Output() mainMenuEvent: EventEmitter<string> = new EventEmitter<string>();
  @Input() role: string;
  currentRole = signal<string>('');
  loggedIn = signal<boolean>(false);

  isAdmin = computed(() => {
    const r = this.currentRole();
    return r === 'admin';
  });

  isClerk = computed(() => {
    const r = this.currentRole();
    return ['admin', 'clerk'].includes(r);
  });

  isWorker = computed(() => {
    const r = this.currentRole();
    return ['admin', 'clerk', 'worker'].includes(r);
  });


  openLoginDialog() {
    this.mainMenuEvent.emit('login');
  }
  logOut() {
    this.mainMenuEvent.emit('logout');
  }
  toggleMenu() {
    this.mainMenuEvent.emit('toogle');
  }
  ngOnInit(): void { }
  ngOnDestroy(): void { }

  ngOnChanges(changes: SimpleChanges): void {
    if(changes.role){
      this.role = changes.role.currentValue;
      this.currentRole.set(this.role);
    }

    if (changes.isLoggedIn) {
      this.isLoggedIn = changes.isLoggedIn.currentValue;
      this.loggedIn.set(this.isLoggedIn);
    }
  }
}
